import { Typography } from '@mui/material';
import React, { DragEvent, useRef } from 'react'
import EXCEL_ICON from "../../../../../images/XLS.png"
import CancelIcon from '@mui/icons-material/Cancel';
import { ACCEPTED_INCLUSION_EXCLUSION_FILE_TYPES } from '../../../utils/utils';
import { DropzoneType } from '../../../types';


/**
 * This component is responsible for reading an excel file by Dragging and dropping in this section
 * @param props 
 * @returns 
 */
function Dropzone(props:DropzoneType) {
    const {handleDrop , handleFileInput,file , handleFileRemove} = props;

    const fileInputRef = useRef<HTMLInputElement>(null);

    const removeFile = ()=>{
        if(fileInputRef && fileInputRef.current){
            fileInputRef.current.value = "";
        }
        handleFileRemove && handleFileRemove();
    }
    const handleDragEnter = (event: DragEvent<HTMLDivElement>)=>{
        event.stopPropagation();
        event.preventDefault();
    }

    const handleDragOver = (event: DragEvent<HTMLDivElement>)=>{
        event.stopPropagation();
        event.preventDefault();
    }

  return (
        <>
         <div className="exclusion-list-file-dropper-wrapper" 
                onDrop={handleDrop}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                >
                <div className="exclusion-list-file-dropper-wrapper-left">
                    <Typography variant='subtitle1'>Drag a file here</Typography>
                    <Typography style={{color:'gray',fontSize:'14px'}}>Or</Typography>
                    <Typography className='exclusion-list-select-excel-button' onClick={()=>{
                        fileInputRef.current?.click();
                      }}>
                          Select an excel sheet
                    </Typography>
                    
                </div>
                <div className="exclusion-list-file-dropper-wrapper-right">
                    <img src={EXCEL_ICON} width={"60px"} height={"60px"} alt='excel-image' style={{cursor:'pointer'}} onClick={()=> fileInputRef.current?.click()}/>
                    {
                        file && file.name && <div className='' style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <Typography>
                                {file?.name}
                            </Typography>
                            <CancelIcon sx={{ color: 'gray', cursor: 'pointer' }} onClick={removeFile}/>
                        </div>
                    }
                </div>
            </div>
              <input type="file" accept={ACCEPTED_INCLUSION_EXCLUSION_FILE_TYPES} className='bulk_upload_input'
                  onChange={handleFileInput} ref={fileInputRef} hidden
              />
    </>
  )
}

export default Dropzone